import React from "react";
import { useTranslation } from "react-i18next";

export const VALID_INTENSITIES = [
  "II ~ IV",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "VIII ~ IX",
];

export const HistoricalEarthquakeSelectorForm = ({ filter, setFilter }) => {
  const { t } = useTranslation();

  const handleInputChanged = (event) => {
    if (event.target && event.target.name) {
      const { name, value, checked } = event.target;
      const [category, key] = name.split(/\.(.+)/);

      if (category === "period") {
        if (key === "enabled") {
          setFilter({
            ...filter,
            period: { ...filter.period, enabled: checked },
          });
        } else {
          setFilter({
            ...filter,
            period: { ...filter.period, [key]: parseInt(value) },
          });
        }
      } else if (category === "intensity") {
        const keyIndex = filter.intensities.indexOf(key);
        if (checked && keyIndex === -1) {
          setFilter({
            ...filter,
            intensities: [...filter.intensities, key],
          });
        } else if (!checked && keyIndex !== -1) {
          const intensities = [...filter.intensities];
          intensities.splice(keyIndex, 1);
          setFilter({ ...filter, intensities });
        }
        // if (key === "enabled") {
        //   setFilter({
        //     ...filter,
        //     intensity: { ...filter.intensity, enabled: checked },
        //   });
        // } else {
        //   const keyIndex = filter.intensity.values.indexOf(key);
        //   if (checked && keyIndex === -1) {
        //     setFilter({
        //       ...filter,
        //       period: {
        //         ...filter.intensity,
        //         values: [...filter.intensity.values, key],
        //       },
        //     });
        //   } else if (!checked && keyIndex !== -1) {
        //     setFilter({
        //       ...filter,
        //       period: {
        //         ...filter.intensity,
        //         values: [...filter.intensity.values.splice(index, 1)],
        //       },
        //     });
        //   }
        // }
      }
    }
  };

  return (
    <>
      <div className="left multiinput_container">
        <label
          className="datatable_select_radio"
          htmlFor="historicalEqfilter.period.enabled"
        >
          <input
            type="checkbox"
            id="historicalEqfilter.period.enabled"
            className="filled-in with-gap"
            name="period.enabled"
            onChange={handleInputChanged}
          />
          <span>{t("w.duration")} (Year)</span>
        </label>
        <input
          type="number"
          min={0}
          name="period.start"
          aria-label="이벤트 기간 시작년"
          placeholder="0"
          className="multiinput inputmid"
          onChange={handleInputChanged}
        />
        &nbsp; ~ &nbsp;
        <input
          type="number"
          min={0}
          name="period.end"
          aria-label="이벤트 기간 종료년"
          placeholder="1904"
          className="multiinput inputmid"
          onChange={handleInputChanged}
        />
      </div>
      <div className="clearfix"></div>
      <div className="mobile_blank"></div>

      <div className=" multiinput_container">
        {t("w.intensity")}:&nbsp;&nbsp;&nbsp;&nbsp;
        {VALID_INTENSITIES.map((intensity) => (
          <label
            key={intensity}
            className="datatable_select_radio"
            style={{ width: 100 }}
            htmlFor={`earthquakefilter.intensity.${intensity}`}
          >
            <input
              type="checkbox"
              id={`earthquakefilter.intensity.${intensity}`}
              className="filled-in with-gap"
              name={`intensity.${intensity}`}
              checked={filter.intensities.includes(intensity)}
              onChange={handleInputChanged}
            />
            <span>{intensity}</span>
          </label>
        ))}
      </div>
      <div className="clearfix"></div>
      <div className="mobile_blank"></div>
    </>
  );
};
